import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { Grid, Typography, CircularProgress } from '@material-ui/core';
import { Utils, Form, Page } from 'ecrion-components';
import React, { useState, useEffect } from 'react';

var GoogleApiKey = function GoogleApiKey() {
  var _useState = useState({
    value: {},
    loading: true,
    error: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = useState({
    submitted: false,
    succeeded: false,
    message: ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      submitState = _useState4[0],
      setSubmitState = _useState4[1];

  var trialLicense = Page.Licensing.useLicense();
  useEffect(function () {
    Utils.request({
      url: '/backend/environmentsettings',
      method: 'GET'
    }).then(function (response) {
      if (!response[0].FormsSettings) return;
      var settings = response[0].FormsSettings;
      if (!settings) return;
      setState({
        value: settings,
        loading: false,
        error: null
      });
    }).catch(function (err) {
      setState({
        value: null,
        loading: false,
        error: Utils.getPrettyError(err)
      });
    });
  }, []);

  var renderContent = function renderContent() {
    return React.createElement(Grid, {
      container: true
    }, React.createElement(Grid, {
      item: true,
      xs: 12,
      md: 6,
      lg: 4
    }, React.createElement(Form.Fields.Text, {
      style: {
        marginLeft: '-16px'
      },
      name: "GoogleApiKey",
      id: "GoogleApiKey",
      label: null
    })));
  };

  var saveRules = function saveRules() {
    return Utils.request({
      url: '/backend/environmentsettings/formsconfiguration',
      data: state.value,
      method: 'PUT'
    }).then(function (response) {
      setSubmitState({
        submitted: true,
        succeeded: true,
        message: 'Saved'
      });
      setTimeout(function () {
        setSubmitState({
          submitted: false,
          succeeded: false,
          message: ''
        });
      }, 3000);
    }).catch(function (error) {
      setSubmitState({
        submitted: true,
        succeeded: false,
        message: error
      });
    });
  };

  return React.createElement(React.Fragment, null, trialLicense.IsTrial ? React.createElement(Form.Error, null, "This feature is not available in Trial Mode") : state.loading ? React.createElement(Loading, null) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "h6"
  }, "Google Api Key"), submitState.submitted && !submitState.succeeded && React.createElement(Form.Error, null, submitState.message), React.createElement(Form.Fragment, {
    renderContent: renderContent,
    submitAlign: "left",
    variant: "filled",
    submitLabel: submitState.submitted && submitState.succeeded ? 'Saved' : 'Save',
    submittingLabel: "Saving...",
    defaultValue: {
      GoogleApiKey: state.value.GoogleApiKey
    },
    disabled: submitState.submitted && submitState.succeeded,
    onSuccess: function onSuccess(data) {
      if (data) {
        var copy = state.value;
        copy.GoogleApiKey = data.GoogleApiKey;
        setState({
          value: copy,
          loading: false,
          error: null
        });
        return saveRules();
      }
    }
  })));
};

var Loading = function Loading() {
  return React.createElement(CircularProgress, {
    size: 60,
    variant: "indeterminate",
    disableShrink: true,
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginLeft: '-25px',
      marginTop: '-25px'
    }
  });
};

export default GoogleApiKey;